import React from "react";
import Tooltip from "@mui/material/Tooltip";
import PropTypes from "prop-types";

export default function TooltipNoInbois({ noInboisList, children }) {
  if (!noInboisList || noInboisList.length === 0) return children;
  return (
    <Tooltip
      title={
        <div
          style={{
            fontSize: 11,
            lineHeight: 1.5,
            maxHeight: 250,
            overflowY: 'auto',
            minWidth: 150,
            paddingRight: 0,
            marginRight: 0,
            scrollbarWidth: 'thin', // Firefox
            scrollbarColor: '#bdbdbd #222', // Firefox
          }}
        >
          <style>{`
            div[role="tooltip"] div::-webkit-scrollbar {
              width: 6px;
              background: #222;
              border-radius: 8px;
            }
            div[role="tooltip"] div::-webkit-scrollbar-thumb {
              background: #bdbdbd;
              border-radius: 8px;
            }
            div[role="tooltip"] div::-webkit-scrollbar-thumb:hover {
              background: #888;
            }
          `}</style>
          <b>No Inbois:</b>
          <br />
          {noInboisList.map((n, i) => (
            <span key={n} style={{ display: "block", fontSize: 13 }}>{n}</span>
          ))}
        </div>
      }
      arrow
      placement="top"
    >
      <span style={{ cursor: "pointer", textDecoration: "underline dotted" }}>{children}</span>
    </Tooltip>
  );
}

TooltipNoInbois.propTypes = {
  noInboisList: PropTypes.arrayOf(PropTypes.string),
  children: PropTypes.node.isRequired,
};
